<template>
  <div>
    <my-asidebar v-bind:active-tab="'booking'"> </my-asidebar>



    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Rezervasyon</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/bookings'" class="text-white">Rezervasyon</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
        <booking-detail></booking-detail>
      </div>
    </section>

  </div>
</template>

<script>
import MyAsidebar from "../component/common/MyAsidebar";
import BookingDetail from "../component/booking/BookingDetail";
import TopBar from "../component/common/TopBar";

export default {
  name: "AgencyListPage",
  components: {TopBar, BookingDetail, MyAsidebar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_BOOKING_DETAIL"]) this.$router.push("/");

    this.$store.commit("clearBookingState");
    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadBooking", this.$route.params.id)
      this.$store.dispatch("loadBookingNotes", {bookingId: this.$route.params.id})
    }else{
      this.$nextTick(()=>{
        this.$store.commit("setBooking",{id:null})
      })
    }

    this.$store.dispatch("loadAgencyList");
    this.$store.dispatch("loadUserList");
    this.$store.dispatch("loadSailsLite");
  }
}
</script>

<style scoped>

</style>